import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Container, Row, Col, Button, Form, Table } from "react-bootstrap";

const Departments = () => {
  const [departments, setDepartments] = useState([]);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  useEffect(() => {
    fetchDepartments();
  }, []);

  const fetchDepartments = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/get-categories`
      );
      setDepartments(res.data.categories);
    } catch (err) {
      Swal.fire("Error", "Failed to fetch departments", "error");
    }
  };

  const handleAddDepartment = async (e) => {
    e.preventDefault();

    if (!name || !description) {
      Swal.fire("Error", "Please fill all fields!", "error");
      return;
    }

    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/add-category`, {
        name,
        description,
      });

      setName("");
      setDescription("");
      fetchDepartments();

      Swal.fire("Success", "Department added successfully!", "success");
    } catch (err) {
      Swal.fire("Error", "Failed to add department", "error");
    }
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This will delete the department permanently!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      try {
        await axios.delete(
          `${process.env.REACT_APP_API_URL}/delete-category/${id}`
        );
        fetchDepartments();
        Swal.fire("Deleted!", "Department deleted successfully.", "success");
      } catch (err) {
        Swal.fire("Error", "Failed to delete department", "error");
      }
    }
  };

  return (
    <Container className="mt-4">
      <h3 className="text-primary mb-4">Departments</h3>

      {/* Add Department Form */}
      <Form
        onSubmit={handleAddDepartment}
        className="mb-4 shadow-sm p-3  rounded"
        style={{ backgroundColor: "aliceblue" }}
      >
        <Row className="g-3">
          <Col md={4}>
            <Form.Control
              type="text"
              placeholder="Department Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </Col>
          <Col md={5}>
            <Form.Control
              type="text"
              placeholder="Description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              required
            />
          </Col>
          <Col md={3}>
            <Button variant="primary" className="w-100 fw-bold" type="submit">
              Add Department
            </Button>
          </Col>
        </Row>
      </Form>

      {/* Departments Table */}
      <Table
        bordered
        hover
        responsive
        className="text-center"
        style={{ backgroundColor: "aliceblue" }}
      >
        <thead className="table-primary">
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Description</th>
            <th style={{ width: "10%" }}>Action</th>
          </tr>
        </thead>
        <tbody>
          {departments.length > 0 ? (
            departments.map((dept, index) => (
              <tr key={dept.id}>
                <td>{index + 1}</td>
                <td>{dept.name}</td>
                <td>{dept.description}</td>
                <td>
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => handleDelete(dept.id)}
                    className="fw-bold"
                  >
                    Delete
                  </Button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4">No departments found.</td>
            </tr>
          )}
        </tbody>
      </Table>
    </Container>
  );
};

export default Departments;
